import { createWebHistory, createRouter } from "vue-router";
import FormSection from "@/components/FormSection.vue";
import AcreditacionFinalizada from "@/components/AcreditacionFinalizada.vue";
import NotFoundSection from "@/components/NotFoundSection.vue";
import CredencialSection from "@/components/CredencialSection.vue";
import PagoSection from "@/components/PagoSection.vue";
import PrensaSection from "@/components/PrensaSection.vue";

const routes = [
  {
    path: "/",
    component: FormSection,
  },
  {
    path: "/prensa",
    component: PrensaSection,
  },
  {
    path: "/credenciales",
    component: CredencialSection,
  },
  {
    path: "/finalizado",
    component: AcreditacionFinalizada,
  },
  {
    path: "/:catchAll(.*)",
    component: NotFoundSection,
  },  
];

import { createWebHashHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes,
  scrollBehavior() {
    return { top: 0 }
  }
});

export default router;